import { useContext } from 'react';
import { VasBudgetLine, VasBudgetLineData, VasBudgetLineImpl } from '../types';
import { COLLECTIONS } from '../firebase/firestoreUtils';
import { createYearScopedAdminCollection } from './yearScopedAdminCollection';

const { Context, Provider } = createYearScopedAdminCollection<VasBudgetLineData, VasBudgetLine>({
    collection: COLLECTIONS.VAS_BUDGET_LINES,
    label: 'Vas budget lines',
    wrap: data => new VasBudgetLineImpl(data),
    toUpdatePayload: line => {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const { id, createdAt, updatedAt, ...rest } = line;
        return rest;
    },
});

export const VasBudgetContext = Context;
export const VasBudgetProvider = Provider;

export const useVasBudget = () => {
    const ctx = useContext(VasBudgetContext);
    if (!ctx) throw new Error('useVasBudget must be used within a VasBudgetProvider');
    return {
        lines: ctx.items,
        isLoading: ctx.isLoading,
        addLine: ctx.add,
        updateLine: ctx.update,
        deleteLine: ctx.remove,
    };
};
